import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=4503a9b8&scoped=true&"
import script from "./SocialIcon.vue?vue&type=script&lang=ts&"
export * from "./SocialIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SocialIcon.vue?vue&type=style&index=0&id=4503a9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503a9b8",
  null
  
)

export default component.exports